import {FC, useEffect, useState} from 'react'
import './MapView.css'
import {useNavigate} from 'react-router-dom'
import {RegisterHelp} from './RegisterHelp'
import {UserHelp} from './UserHelp'
import {ServiceHelp} from './ServiceHelp'
import axios from 'axios'
import {useAuth} from '../../../../app/modules/auth'
import {API_URL, isNotEmpty, projectName} from '../../crud-helper/helpers'
import clsx from 'clsx'
import {staffCan} from '../../../../app/modules/auth/core/staffAccess'

type companyProgress = {
  companyId: number
  isConfirm: boolean
  companyType?: 1 | 2
  companyName?: string
  nationalCode?: string
  userCount?: number
  accountCount?: number
  serviceCount?: number
  customerUserCount?: number
  customerCompanyCount?: number
  plan?: boolean
}

type prop = {
  title?: boolean
  companyId?: number
  onlyMap?: boolean
}

const MapView: FC<prop> = ({title = false, companyId, onlyMap = false}) => {
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const [first, setFirst] = useState(true)
  const [loaded, setLoaded] = useState(false)
  const [registerHelp, setRegisterHelp] = useState(false)
  const [userHelp, setUserHelp] = useState(false)
  const [serviceHelp, setServiceHelp] = useState(false)
  const [data, setData] = useState<companyProgress>()

  useEffect(() => {
    if (first) {
      setFirst(false)
      axios.post(`${API_URL}/auth/companyProgress/`, {companyId}).then((response) => {
        setData(response.data)
        setLoaded(true)
      })
    }
  }, [])

  return (
    <>
      <div>
        <div className={clsx('mapview w-100 px-7', {'py-7': title})}>
          {title && <h1 className='text-center'>دستیار {projectName}</h1>}
          <div className='row'>
            {!onlyMap && (
              <div className='col-5'>
                <p style={{textAlign: 'justify'}} className='mt-5'>
                  «دستیار {projectName} یک راهنمای قدم به قدم است که به شما کمک می‌کند تا به راحتی و
                  بدون نیاز به دانش فنی، اطلاعات شرکت خود را وارد کنید و تنظیمات لازم را انجام دهید.
                  <br />
                  <br />
                  با کلیک بر هر مرحله از این نمودار گردش کار، به بخش مربوطه هدایت می‌شوید. همچنین،
                  برای هر بخش یک ویدیو آموزشی کوتاه نیز در دسترس است که می‌توانید آن را مشاهده کنید.
                  (روی ? کلیک کنید)
                  <br />
                  <br />
                  برای هر مرحله از فرآیند، رنگ سبز در نمودار گردش کار نشان می‌دهد که آن مرحله را
                  تکمیل کرده‌اید، و اگر مرحله‌ای را تکمیل نکرده باشید، با رنگ زرد در نمودار گردش کار
                  نشان می‌دهد که آن مرحله هنوز باقی مانده است.
                  <br />
                  <br />
                  پس نگران نباشید! «دستیار {projectName}» در هر قدم کنار شماست تا به شما کمک کند. با
                  این حال، می‌توانید از طریق ویدیو زیر، آموزش کلی کار را ببینید.
                </p>
                {/* <div className='text-center mt-5'>
                <div className='h_iframe-aparat_embed_frame'>
                  <iframe
                    src='https://www.aparat.com/video/video/embed/videohash/5rBNe/vt/frame?titleShow=true&muted=true&autoplay=true&recom=self'
                    allowFullScreen={true}
                  ></iframe>
                </div>
              </div> */}
              </div>
            )}
            <div className={clsx({'col-12': onlyMap}, {'col-7': onlyMap})}>
              {!loaded && (
                <div className='w-100 text-center pt-10'>
                  <i className='las la-spinner la-spin fs-3x text-primary'></i>
                </div>
              )}
              {loaded && data && (
                <nav className='nav'>
                  <ul>
                    <li>
                      <a className={clsx({'bg-light-success': currentUser && currentUser?.ftn})}>
                        {currentUser && currentUser?.ftn && (
                          <i className='las la-check-double text-success fs-6 me-2'></i>
                        )}
                        <span className='link-success' onClick={() => navigate('/profile')}>
                          ثبت نام
                        </span>
                      </a>
                      <ul>
                        <li>
                          <a className={clsx({'bg-light-success': data.companyType})}>
                            <span>
                              {data.companyType ? (
                                <>
                                  <i className='las la-check-double text-success fs-6 me-2'></i>
                                  <span
                                    className='link-success'
                                    onClick={() =>
                                      navigate(
                                        `/apps/taxpayer-management/setting/${data.companyId}`
                                      )
                                    }
                                  >
                                    {data.companyName}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <i
                                    className='las la-spinner la-spin fs-4 text-warning me-2'
                                    title='در حال تکمیل'
                                  ></i>
                                  {staffCan(currentUser, 'businesses', 'manage') && (
                                    <span
                                      className='link-primary'
                                      onClick={() => navigate('/taxpayer/register')}
                                    >
                                      تعریف کسب‌وکار جدید
                                    </span>
                                  )}
                                </>
                              )}
                              <i
                                onClick={() => setRegisterHelp(true)}
                                className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                title='راهنما'
                              ></i>
                            </span>
                          </a>
                          <ul>
                            <li>
                              <a
                                className='bg-light-success link-success'
                                onClick={() =>
                                  navigate(`/apps/taxpayer-management/setting/${data.companyId}`)
                                }
                              >
                                <span>
                                  <i className='las la-cog fs-3 me-2 link-success'></i>
                                  تنظیمات کلی
                                </span>
                              </a>
                              <ul>
                                <li>
                                  <a
                                    className={clsx({
                                      'bg-light-success': data.userCount && data.userCount > 0,
                                    })}
                                  >
                                    {data.companyType ? (
                                      <span>
                                        {(data.userCount || 0) > 0 ? (
                                          <>
                                            <span className='badge badge-circle badge-success me-2'>
                                              {data.userCount}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <i
                                              className='las la-spinner la-spin fs-4 text-warning me-2'
                                              title='در حال تکمیل'
                                            ></i>
                                          </>
                                        )}
                                        <span
                                          className={`link-${
                                            data.userCount || 0 > 0 ? 'success' : 'primary'
                                          }`}
                                          onClick={() =>
                                            navigate(
                                              `/apps/taxpayer-management/setting/${data.companyId}/users`
                                            )
                                          }
                                        >
                                          معرفی کاربران سیستم
                                        </span>
                                        <i
                                          onClick={() => setUserHelp(true)}
                                          className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                          title='راهنما'
                                        ></i>
                                      </span>
                                    ) : (
                                      <span>معرفی کاربران سیستم</span>
                                    )}
                                  </a>
                                  <ul>
                                    {/* <li>
                                  <a
                                    className={clsx({
                                      'bg-light-success':
                                        data.accountCount && data.accountCount > 0,
                                    })}
                                  >
                                    {data.companyType ? (
                                      <span>
                                        {(data.accountCount || 0) > 0 ? (
                                          <>
                                            <span className='badge badge-circle badge-success me-2'>
                                              {data.accountCount}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <i
                                              className='las la-spinner la-spin fs-4 text-warning me-2'
                                              title='در حال تکمیل'
                                            ></i>
                                          </>
                                        )}
                                        <span
                                          className={`link-${
                                            data.accountCount || 0 > 0 ? 'success' : 'primary'
                                          }`}
                                          onClick={() => navigate('/register/login')}
                                        >
                                          اطلاعات حساب‌ها / POS
                                        </span>
                                        <i
                                          onClick={() => setUserHelp(true)}
                                          className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                          title='راهنما'
                                        ></i>
                                      </span>
                                    ) : (
                                      <span>اطلاعات حساب‌ها / POS</span>
                                    )}
                                  </a>
                                  <ul> */}
                                    <li>
                                      <a
                                        className={clsx({
                                          'bg-light-success':
                                            data.serviceCount && data.serviceCount > 0,
                                        })}
                                      >
                                        {data.companyType ? (
                                          <span>
                                            {(data.serviceCount || 0) > 0 ? (
                                              <>
                                                <span className='badge badge-circle badge-success me-2'>
                                                  {data.serviceCount}
                                                </span>
                                              </>
                                            ) : (
                                              <>
                                                <i
                                                  className='las la-spinner la-spin fs-4 text-warning me-2'
                                                  title='در حال تکمیل'
                                                ></i>
                                              </>
                                            )}
                                            <span
                                              className={`link-${
                                                data.serviceCount || 0 > 0 ? 'success' : 'primary'
                                              }`}
                                              onClick={() => navigate('/apps/product-management')}
                                            >
                                              معرفی کالا/خدمات
                                            </span>
                                            <i
                                              onClick={() => setServiceHelp(true)}
                                              className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                              title='راهنما'
                                            ></i>
                                          </span>
                                        ) : (
                                          <span>معرفی کالا/خدمات</span>
                                        )}
                                      </a>
                                      <ul>
                                        <li>
                                          <a
                                            className={clsx({
                                              'bg-light-success':
                                                (data.customerUserCount &&
                                                  data.customerUserCount > 0) ||
                                                (data.customerCompanyCount &&
                                                  data.customerCompanyCount > 0),
                                            })}
                                          >
                                            {data.companyType ? (
                                              <span>
                                                {(data.customerUserCount &&
                                                  data.customerUserCount > 0) ||
                                                (data.customerCompanyCount &&
                                                  data.customerCompanyCount > 0) ? (
                                                  <>
                                                    <span className='badge badge-circle badge-success me-2'>
                                                      {(data.customerUserCount || 0) +
                                                        (data.customerCompanyCount || 0)}
                                                    </span>
                                                  </>
                                                ) : (
                                                  <>
                                                    <i
                                                      className='las la-spinner la-spin fs-4 text-warning me-2'
                                                      title='در حال تکمیل'
                                                    ></i>
                                                  </>
                                                )}
                                                <span
                                                  className={`text-${
                                                    (data.customerUserCount &&
                                                      data.customerUserCount > 0) ||
                                                    (data.customerCompanyCount &&
                                                      data.customerCompanyCount > 0)
                                                      ? 'success'
                                                      : 'primary'
                                                  }`}
                                                >
                                                  معرفی خریداران
                                                </span>
                                                <i
                                                  onClick={() => setServiceHelp(true)}
                                                  className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                                  title='راهنما'
                                                ></i>
                                              </span>
                                            ) : (
                                              <span>معرفی خریداران</span>
                                            )}
                                          </a>
                                          <ul>
                                            <li>
                                              <a
                                                className={clsx({
                                                  'bg-light-success':
                                                    data.customerCompanyCount &&
                                                    data.customerCompanyCount > 0,
                                                })}
                                              >
                                                {data.companyType ? (
                                                  <span>
                                                    {data.customerCompanyCount &&
                                                    data.customerCompanyCount > 0 ? (
                                                      <>
                                                        <span className='badge badge-circle badge-success me-2'>
                                                          {data.customerCompanyCount}
                                                        </span>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <i
                                                          className='las la-spinner la-spin fs-4 text-warning me-2'
                                                          title='در حال تکمیل'
                                                        ></i>
                                                      </>
                                                    )}
                                                    <span
                                                      className={`link-${
                                                        data.customerCompanyCount &&
                                                        data.customerCompanyCount > 0
                                                          ? 'success'
                                                          : 'primary'
                                                      }`}
                                                      onClick={() =>
                                                        navigate(
                                                          '/apps/customer-management/companies'
                                                        )
                                                      }
                                                    >
                                                      حقوقی
                                                    </span>
                                                    <i
                                                      onClick={() => setServiceHelp(true)}
                                                      className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                                      title='راهنما'
                                                    ></i>
                                                  </span>
                                                ) : (
                                                  <span>حقوقی</span>
                                                )}
                                              </a>
                                              <ul>
                                                {/* <li>
                                                  <a
                                                    className={clsx({
                                                      'bg-light-success': data.plan,
                                                    })}
                                                  >
                                                    {data.companyType ? (
                                                      <span>
                                                        {data.plan ? (
                                                          <></>
                                                        ) : (
                                                          <>
                                                            <i
                                                              className='las la-spinner la-spin fs-4 text-warning me-2'
                                                              title='در حال تکمیل'
                                                            ></i>
                                                          </>
                                                        )}
                                                        <span
                                                          className={`link-${
                                                            data.plan ? 'success' : 'primary'
                                                          }`}
                                                          onClick={() =>
                                                            (window.location.href =
                                                              'https://mega-pay.net/%D9%86%D8%B1%D9%85-%D8%A7%D9%81%D8%B2%D8%A7%D8%B1-%D8%B3%D8%A7%D9%85%D8%A7%D9%86%D9%87-%D9%85%D9%88%D8%AF%DB%8C%D8%A7%D9%86-%D9%85%DA%AF%D8%A7%D9%BE%DB%8C/')
                                                          }
                                                        >
                                                          انتخاب پلن
                                                        </span>
                                                        <i
                                                          onClick={() => setServiceHelp(true)}
                                                          className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                                          title='راهنما'
                                                        ></i>
                                                      </span>
                                                    ) : (
                                                      <span>انتخاب پلن</span>
                                                    )}
                                                  </a>
                                                  <ul> */}
                                                <li>
                                                  <a href='/apps/invoice-management/invoices'>
                                                    صدور پیش‌صورتحساب
                                                  </a>
                                                  <ul>
                                                    <li>
                                                      <a href='/apps/invoice-management/invoices'>
                                                        صدور صورتحساب
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </li>
                                                {/* </ul>
                                                </li> */}
                                              </ul>
                                            </li>
                                            <li>
                                              <a
                                                className={clsx({
                                                  'bg-light-success':
                                                    data.customerUserCount &&
                                                    data.customerUserCount > 0,
                                                })}
                                              >
                                                {data.companyType ? (
                                                  <span>
                                                    {data.customerUserCount &&
                                                    data.customerUserCount > 0 ? (
                                                      <>
                                                        <span className='badge badge-circle badge-success me-2'>
                                                          {data.customerUserCount}
                                                        </span>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <i
                                                          className='las la-spinner la-spin fs-4 text-warning me-2'
                                                          title='در حال تکمیل'
                                                        ></i>
                                                      </>
                                                    )}
                                                    <span
                                                      className={`link-${
                                                        data.customerUserCount &&
                                                        data.customerUserCount > 0
                                                          ? 'success'
                                                          : 'primary'
                                                      }`}
                                                      onClick={() =>
                                                        navigate('/apps/customer-management/users')
                                                      }
                                                    >
                                                      حقیقی
                                                    </span>
                                                    <i
                                                      onClick={() => setServiceHelp(true)}
                                                      className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                                      title='راهنما'
                                                    ></i>
                                                  </span>
                                                ) : (
                                                  <span>حقیقی</span>
                                                )}
                                              </a>
                                              <ul>
                                                {/* <li>
                                                  <a
                                                    className={clsx({
                                                      'bg-light-success': data.plan,
                                                    })}
                                                  >
                                                    {data.companyType ? (
                                                      <span>
                                                        {data.plan ? (
                                                          <></>
                                                        ) : (
                                                          <>
                                                            <i
                                                              className='las la-spinner la-spin fs-4 text-warning me-2'
                                                              title='در حال تکمیل'
                                                            ></i>
                                                          </>
                                                        )}
                                                        <span
                                                          className={`link-${
                                                            data.plan ? 'success' : 'primary'
                                                          }`}
                                                          onClick={() =>
                                                            (window.location.href =
                                                              'https://mega-pay.net/%D9%86%D8%B1%D9%85-%D8%A7%D9%81%D8%B2%D8%A7%D8%B1-%D8%B3%D8%A7%D9%85%D8%A7%D9%86%D9%87-%D9%85%D9%88%D8%AF%DB%8C%D8%A7%D9%86-%D9%85%DA%AF%D8%A7%D9%BE%DB%8C/')
                                                          }
                                                        >
                                                          انتخاب پلن
                                                        </span>
                                                        <i
                                                          onClick={() => setServiceHelp(true)}
                                                          className='las la-question fs-4 link-primary text-gray-600 ms-2'
                                                          title='راهنما'
                                                        ></i>
                                                      </span>
                                                    ) : (
                                                      <span>انتخاب پلن</span>
                                                    )}
                                                  </a>
                                                  <ul> */}
                                                <li>
                                                  <a href='/apps/invoice-management/invoices'>
                                                    صدور پیش‌صورتحساب
                                                  </a>
                                                  <ul>
                                                    <li>
                                                      <a href='/apps/invoice-management/invoices'>
                                                        صدور صورتحساب
                                                      </a>
                                                    </li>
                                                  </ul>
                                                </li>
                                                {/* </ul>
                                                </li> */}
                                              </ul>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </li>
                                    {/* </ul>
                                </li> */}
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
      {registerHelp && <RegisterHelp setRegisterHelp={setRegisterHelp} />}
      {userHelp && <UserHelp setUserHelp={setUserHelp} />}
      {serviceHelp && <ServiceHelp setServiceHelp={setServiceHelp} />}
    </>
  )
}

export {MapView}
